import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App.jsx'
import { ThemeProvider } from './context/ThemeContext'
import { isPlatformSessionFailure } from './utils/authRedirect'
import './index.css'
import './app.css'

if (!window.__acuonAuthRedirectInstalled) {
  window.__acuonAuthRedirectInstalled = true
  const originalFetch = window.fetch.bind(window)
  const loginPaths = ['/login', '/reset-password']
  const authRequestPaths = [
    '/auth/login',
    '/auth/login/verify',
    '/auth/register',
    '/auth/activate',
    '/auth/request-password-reset',
    '/auth/reset-password',
    '/customer-auth/login',
    '/customer-auth/login/verify',
    '/customer-auth/register',
    '/customer-auth/activate'
  ]
  window.fetch = async (input, init) => {
    const response = await originalFetch(input, init)
    const requestUrl = typeof input === 'string' ? input : input?.url || ''
    const requestHeaders = init?.headers || (typeof input === 'object' ? input?.headers : null)
    const requestPath = (() => {
      try {
        return new URL(requestUrl, window.location.origin).pathname
      } catch {
        return requestUrl
      }
    })()

    const isLoginPage = loginPaths.includes(window.location.pathname)
    const isAuthRequest = authRequestPaths.some((path) => requestPath.endsWith(path))
    if (isLoginPage || isAuthRequest) return response

    let shouldRedirect = false
    if (response.status === 401) {
      try {
        const payload = await response.clone().json()
        shouldRedirect = isPlatformSessionFailure({
          status: response.status,
          requestHeaders,
          payload
        })
      } catch {
        shouldRedirect = false
      }
    }

    if (shouldRedirect) {
      localStorage.removeItem('authToken')
      localStorage.removeItem('userData')
      localStorage.removeItem('tenantId')
      window.location.replace('/login')
    }

    return response
  }
}

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <ThemeProvider>
      <App />
    </ThemeProvider>
  </React.StrictMode>,
)
